export default [
    {
        path: "/DetailPage", //云上展厅展商详情页
        name: "DetailPage",
        component: () => import("@/view/CloudFair/Showroom/DetailPage.vue")
    },
    {
        path: "/ProjectDetails", //云上展厅展商项目详情页
        name: "ProjectDetails",
        component: () => import("@/view/CloudFair/Showroom/ProjectDetails.vue")
    },
      {
        path: "/MeetingDetails", //会议详情
        name: "MeetingDetails",
        component: () => import("@/view/CloudFair/Meeting/MeetingDetails.vue")
      },
      {
        path: "/Appointment", //要客预约
        name: "Appointment",
        component: () => import("@/view/CloudFair/Appointment/index.vue")
      },
      {
        path: "/login", //登录
        name: "login",
        component: () => import("@/view/CloudFair/login/login.vue")
      },
      {
        path: "/register", //注册
        name: "register",
        component: () => import("@/view/CloudFair/register/index.vue")
      },
      {
        path: '/governmentGuests', //政府要客
        name: 'governmentGuests',
        component:() => import("@/view/CloudFair/Appointment/governmentGuests.vue")
      },
      {
        path: '/bookedCapital', //预约资本
        name: 'bookedCapital',
        component:() => import("@/view/CloudFair/Appointment/bookedCapital.vue")
      },
      {
        path: '/exhibitorAppointment', //预约展商
        name: 'exhibitorAppointment',
        component:() => import("@/view/CloudFair/Appointment/exhibitorAppointment.vue")
      },
      {
        path: '/vipAppointment', //要客详情
        name: 'vipAppointment',
        component:() => import("@/view/CloudFair/Appointment/vipAppointment.vue")
      },
      {
        path: '/apppintmentMerchant', //预约客商
        name: 'apppintmentMerchant',
        component:() => import("@/view/CloudFair/Appointment/apppintmentMerchant.vue")
      }

]


// WEBPACK FOOTER //
// ./src/router/cloudFair/bs.js